// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"toolTip__wrapper__2NGQY","content":"toolTip__content__29MG7","text":"toolTip__text__-LjRZ"};